








import Vue from "vue";
import { mapGetters } from "vuex";

export default Vue.extend({
  name: "Alert",
  data: () => {
    return {
      currentComponent: null as null
    };
  },
  computed: {
    ...mapGetters(["GET_ALERT_STATUS"])
  },
  watch: {
    GET_ALERT_STATUS(state): void {
      !state.component ? null : this.loadComponent();
    }
  },
  methods: {
    loadComponent(): void {
      const component: string = this.GET_ALERT_STATUS.component;
      import(
        `@/components/alerts/Alert${component
          .charAt(0)
          .toUpperCase()}${component.slice(1)}.vue`
      )
        .then(res => (this.currentComponent = res.default))
        .catch(error => console.log(error));
    }
  }
});
